import { buildContextStore } from "../../stores/buildContext";
import { get } from "svelte/store";

export type ErrorHandlingOptions = {
  skipAllErrorHandling?: boolean;
};

export const handleError = (error: unknown, options: ErrorHandlingOptions) => {
  return get(buildContextStore).apiUtils.handleError(error, options);
};

export const getPersistedJwt = () => get(buildContextStore).apiUtils.getPersistedJwt();
